module.exports = __webpack_public_path__ + "img/Roboto-Light.9a5aa034.svg";